<template>
    <transition name="fade">
        <div v-transfer-dom :data-transfer="true" :class="prefixCls" v-show="value">
            <div ref="selectFrame"
                :class="`${prefixCls}-wrapper`" 
                :style="position">
                <div :class="`${prefixCls}-header`">
                    <div ref="dragBar" :class="`${prefixCls}-header-title`">
                        {{title || (selectType === 'member' ? t('selectMember.title') : t('selectMember.titleRange'))}}
                    </div>
                    <div :class="`${prefixCls}-header-search`">
                        <input
                            ref="searchInput"
                            :class="searchClasses"
                            v-model="keyword" 
                            type="text" 
                            @keydown.enter="handleSearch">
                        <span @click="handleFocus" 
                            :class="`${prefixCls}-header-search-icon`"></span>
                    </div>
                    <span :class="`${prefixCls}-header-close`" @click="handleCancel">
                        <Icon size="14px" type="cross"/>
                    </span>
                </div>
                <div :class="`${prefixCls}-body`">
                    <Section 
                        v-if="value"
                        ref="section"
                        :tabs="tabs"
                        :customTabs="customTabs"
                        :defaultActiveTab="defaultActiveTab"
                        :insearch="insearch"
                        @handleSelected="handleSelected" />
                    <Selected 
                        @handleSelected="handleSelected" 
                        :selected="selected"
                        :limit="limit" />
                </div>
                <div :class="`${prefixCls}-footer`">
                    <p :class="`${prefixCls}-footer-warning`">
                        <span v-if="selectedCount >= limit">
                            <span v-if="language === 'zhs'">单次最多选择{{this.limit}}条数据</span>
                            <span v-if="language === 'zht'">單次最多選擇{{this.limit}}條數據</span>
                            <span v-if="language === 'en'">Select up to {{this.limit}} data in a single time</span>
                        </span>
                    </p>
                    <div>
                        <Button type="default" @click="handleCancel">
                            {{t('selectMember.cancel')}}
                        </Button>
                        <Button type="primary" :style="{ marginLeft: '4px' }" @click="handleOk">
                            {{t('selectMember.ok')}}
                        </Button>
                    </div>
                </div>
                <div v-if="enableResize" ref="resizeBar" class="resize-bar resize-br"></div>
            </div>
        </div>
    </transition>
</template>
<script>
    import Selected from './selected'
    import Section from './section'
    import Button from '../../base/button/'
    import Icon from '../../base/icon/'
    import Locale from '../../../mixins/locale'
    import { oneOf, deepCopy } from '../../../utils/assist'
    import { t, getLang } from '../../../locale/'
    import TransferDom from '../../../directives/transfer-dom'

    const prefixCls = 'yy-select-member'
    const host = `${window.location.protocol}//${window.location.host}`
    const types = {
        0: {
            key: 'member',
            id: 'memberId'
        },
        1: {
            key: 'dept',
            id: 'deptId'
        },
        3: {
            key: 'group',
            id: 'gid'
        },
        4: {
            key: 'team',
            id: 'id'
        }
    }
    export default {
        name: 'SelectMember',
        mixins: [Locale],
        provide() {
            return {
                root: this
            }
        },
        props: {
            value: {
                type: Boolean,
                default: true
            },
            qzId: {
                type: [String, Number],
                required: true
            },
            /**
             * 根组织列表 
             * [{deptId: 0, deptName: '用友网络科技股份有限公司'}]
             */
            deptList: { 
                type: Array
            },
            /** 
             * 选择组织类型 
             * 0全部 
             * 1仅部门
             * 2仅组织 
             * */
            chooseDeptType: { 
                validator: function(value) {
                    return oneOf(value, [0, 1, 2, '0', '1', '2'])
                },
                default: 0
            },
            /** 
             * 选择组织下人员类型 
             * 0当前组织下全部人员
             * 1只属于当前组织人员
             * */
            chooseDeptMemberType: { 
                validator: function(value) {
                    return oneOf(value, [0, 1, '0', '1'])
                },
                default: 0
            },
            /**
             * ckaoke: http://ezone.yyuap.com:6058/
             * daily: https://ezone.yyuap.com/
             * 预发布: https://pub.esn.ren/
             * 线上:   https://ezone.yonyoucloud.com/
             */
            host: { // 接口地址 支持自定义 
                type: String,
                default: host
            },
            title: { // 标题
                type: String
            },
            limit: { // 人数限制
                type: Number,
                default: 1500
            },
            enableContainChild: { // 是否允许包含下级
                type: Boolean,
                default: false
            },
            enableCatche: { // 是否允许缓存
                type: Boolean,
                default: false
            },
            catchName: { // 缓存名称
                type: String,
                default: 'YYSelectMemberData'
            },
            enableDrag: { // 是否允许拖拽
                type: Boolean,
                default: true
            },
            enableResize: { // 是否允许改变窗口大小
                type: Boolean,
                default: true
            },
            selectType: {
                validator: function(value) {
                    return oneOf(value, ['member', 'range'])
                },
                default: 'member'
            },
            enableDeptIds: { // 允许选择的deptId集合
                type: Array
            },
            defineTabs: { // 自定义已存在页签
                type: Array
            },
            // customTabs 数据格式
            // [
            //     {
            //         title: '单据相关人员',
            //         key: 'cooperation',
            //         data: [
            //             {
            //                 memberId: 123,
            //                 userName: 'nizhja',
            //                 checked: true
            //             }
            //         ]
            //     }
            // ]
            customTabs: { // 自定义页签扩展
                type: Array
            },
            defaultActiveTab: { // 默认激活页签
                type: String
            },
            haveSelected: { // 回显数据 当开启缓存回显时失效
                type: Object,
                default: function() {
                    return {
                        dept: {},
                        group: {},
                        team: {},
                        member: {}
                    }
                }
            }
        },
        data() {
            return {
                prefixCls: prefixCls,
                selected: {
                    dept: {},
                    group: {},
                    team: {},
                    member: {}
                },
                position: {
					width: '800px',
                    height: '600px',
                    minWidth: '800px',
                    minHeight: '600px',
					left: '50%',
                    top: '50%',
                    marginLeft: '-400px',
                    marginTop: '-300px'
                },
                keyword: '',
                language: getLang(),
                isFocus: false,
                insearch: false,
                selectedCount: 0,
            }
        },
        components: {
            Selected,
            Section,
            Button,
            Icon
        },
        directives: {
            TransferDom
        },
        computed: {
            searchClasses() {
                return [
                    `${prefixCls}-header-search-input`,
                    {
                        [`${prefixCls}-header-search-input-focused`]: this.isFocus
                    }
                ]
            },
            tabs() {
                if(this.defineTabs) return this.defineTabs
                if(this.selectType === 'member') return [
                    'deptMember',
                    'member',
                    'groupMember',
                    'teamMember',
                ]
                return [
                    'dept',
                    'member',
                    'group',
                    'team',
                ]
            }
        },
        watch: {
            value: function(newValue) { // 监听是否打开组件
                if(this.enableCatche && !newValue) {
                    return localStorage.setItem(this.catchName, JSON.stringify(this.selected))
                }
                const selected = this.setSelectedType()
                if(this.enableCatche) { // 允许缓存直接从缓存拿
                    const catchSelected = JSON.parse(localStorage.getItem(this.catchName))
                    this.$set(this, 'selected', {
                        ...this.selected,
                        ...catchSelected || deepCopy(selected)
                    })
                } else {
                    this.$set(this, 'selected', {
                        ...this.selected,
                        ...deepCopy(selected)
                    })
                }
                this.setSelectedCount()
            }
        },
        methods: {
            setSelectedType() {
                let selected = deepCopy(this.haveSelected)
                const types = {
                    member: 0,
                    dept: 1,
                    grou: 3,
                    team: 4
                }
                for(let k in selected) {
                    for(let j in selected[k]) {
                        selected[k][j].type = types[k]
                    }
                }
                return selected
            },
            setSelectedCount() { // 设置当前已选数量
                const selected = this.selected
                let count = 0
                Object.keys(selected).forEach((key)=>{
                    count += Object.keys(selected[key]).length
                })
                this.selectedCount = count
                return count
            },
            handleSelected(data) {
                if(data.checked && this.selectedCount >= this.limit) return
                const key = types[data.type].key
                const id = data[types[data.type].id]
                if(data.checked) {
                    this.$set(this.selected[key], id, data)
                    this.setSelectedCount()
                    return
                }

                let param = this.selected[key][id]
                if(param && param.type === 0 && param.parent && !data.checked) {
                    param.parent.indeterminate = false
                }
                this.$set(this.selected[key], id, null)
                delete this.selected[key][id]
                this.setSelectedCount()
                return 
            },
            handleClear() {
                this.selectedCount = 0
                Object.keys(this.selected.member).forEach((key)=>{
                    let member = this.selected.member[key]
                    if(member.parent) {
                        member.parent.indeterminate = false
                    }
                })
                this.$set(this, 'selected', {
                    dept: {},
                    group: {},
                    team: {},
                    member: {}
                })
            },
            handleFocus() {
                this.isFocus = !this.isFocus
                if(this.isFocus) this.$refs.searchInput.focus()
                if(!this.isFocus) {
                    this.insearch = false 
                    this.keyword = ''
                }
            },
            handleSearch() {
                this.insearch = true
            },
            handleCancel() {
                this.$emit('input', false)
            },
            handleOk() { // 点击确定
                this.$emit('input', false)
                this.$emit('on-ok', this.selected)
            },
            setFramePosition(position) { // 设置当前窗体位置
                if(position.left || position.top) {
                    this.position['marginLeft'] = 0
                    this.position['marginTop'] = 0
                }
                this.position = {
                    ...this.position,
                    ...position
                }
            },
            initDrag() { // 初始化拖拽移动窗口
                if(!this.enableDrag) return
                const frame = this.$refs.selectFrame
                const handle = this.$refs.dragBar
                const docElement = document.documentElement
                const _this = this
                handle.onmousedown = function(event) {
                    let dEvent = event || window.event
                    let disX = dEvent.clientX - frame.offsetLeft
                    let disY = dEvent.clientY - frame.offsetTop

                    document.onmousemove = function(event) {
                        let mEvent = event || window.event
                        let iL = mEvent.clientX - disX
                        let iT = mEvent.clientY - disY
                        let maxL = docElement.clientWidth - frame.offsetWidth
                        let maxT = docElement.clientHeight - frame.offsetHeight
                        iL <= 0 && (iL = 0)
                        iT <= 0 && (iT = 0)
                        iL >= maxL && (iL = maxL)
                        iT >= maxT && (iT = maxT)
                
                        _this.setFramePosition({
                            left: iL + "px",
                            top: iT + "px",
                        })
                        return false
                    }

                    document.onmouseup = function() {
                        document.onmousemove = null;
                        document.onmouseup = null;
                    }
                    return false
                }
            },
            initResize() { // 初始化拖拽改变窗口大小
                if(!this.enableResize) return
                const frame = this.$refs.selectFrame
                const resizeBar = this.$refs.resizeBar
                const _this = this
                let position = {
                    ...this.position
                }
                function resize(frame, handle, isLeft, isTop, lockX, lockY) {
                    handle.onmousedown = function(event) {
                        let dEvent = event || window.event
                        let disX = dEvent.clientX - handle.offsetLeft
                        let disY = dEvent.clientY - handle.offsetTop

                        let iParentTop = frame.offsetTop
                        let iParentLeft = frame.offsetLeft
                        let iParentWidth = frame.offsetWidth
                        let iParentHeight = frame.offsetHeight
                        let lastHeight = 0;

                        document.onmousemove = function(event) {
                            let mEvent = event || window.event
                            let iL = mEvent.clientX - disX
                            let iT = mEvent.clientY - disY

                            let maxW = document.documentElement.clientWidth - frame.offsetLeft - 2
                            let maxH = document.documentElement.clientHeight - frame.offsetTop - 2;
                            let maxL = document.documentElement.clientWidth - parseInt(position.width) - 2
                            let maxT = document.documentElement.clientHeight - parseInt(position.height) - 2

                            let iW = isLeft ? iParentWidth - iL : handle.offsetWidth + iL
                            mEvent.clientY > 0 && (lastHeight = iParentHeight - iT)
                            let iH = isTop ? (mEvent.clientY <= 0 ? lastHeight : iParentHeight - iT) : handle.offsetHeight + iT
                            isLeft && (position.left = Math.min((iParentLeft + iL), maxL) + "px")
                            isTop && (position.top = Math.max(Math.min((iParentTop + iT), maxT), 0) + "px")

                            iW < parseInt(position.minWidth) && (iW = parseInt(position.minWidth))
                            iW > maxW && (iW = maxW)
                            lockX || (position.width = iW + "px")
                            iH < parseInt(position.minHeight) && (iH = parseInt(position.minHeight))
                            iH > maxH && (iH = maxH)
                            lockY || (position.height = iH + "px")
                            if((isLeft && iW == parseInt(position.minWidth)) || (isTop && iH == parseInt(position.minHeight))) {
                                document.onmousemove = null
                            }
                           
                            _this.setFramePosition({
                                width: position.width,
                                height: position.height
                            })
                            return false
                        };

                        document.onmouseup = function() {
                            document.onmousemove = null
                            document.onmouseup = null
                        };
                        return false
                    }
                }

                const onresize = function() {
                    resize(frame, resizeBar, false, false, false, false)
                    const docElement = document.documentElement
                    position.left = (docElement.clientWidth - 800) / 2 + "px";
                    position.top = (docElement.clientHeight - 600) / 2 + "px";
                    _this.setFramePosition({
                        width: '800px',
                        height: '600px',
                        left: position.left,
                        top: position.top
                    })
                }

                window.onresize = onresize
                onresize()
            },
            initRevert() {
                if(!this.enableResize) return
                const handle = this.$refs.dragBar
                const _this = this
                let last = {}
                let isMax = false
                handle.ondblclick = function() {
                    if(!isMax) {
                        last = _this.position
                        isMax = true
                        _this.setFramePosition({
                            left: '0',
                            top: '0',
                            width: '100%',
                            height: '100%',
                        }) 

                    } else {
                        isMax = false
                        _this.setFramePosition(last) 
                    }
                }
            },
            init() {
                this.initDrag()
                this.initResize()
                this.initRevert()
            }
        },
        mounted() {
            this.init()
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/business/select-member/select-member.vue